<template>
  <div class="navbar">
    <div class="navbar__logo-container" ref="logo">
      <img
        class="navbar__logo"
        :class="{'navbar__logo--rotated': logoRotated}"
        src="@/assets/chatbotspl_logo_white.png"
        alt="Logo"
      >
    </div>
    <div class="navbar__content">
      <div class="navbar__segment">
        <div
          class="navbar__route-name"
        >{{ (!$route.meta.plugin) ? $t('view.'+($route.name).toLowerCase()+'.viewTitle') : $t(`plugins.${$route.meta.pluginPrefix}.${$route.meta.localeKey}`) }}</div>
      </div>
      <div class="navbar__filler"></div>
      <div class="navbar__segment">
        <div class="navbar__buttons">
          <popper ref="localePopper" trigger="clickToOpen" :options="{ placement: 'bottom' }">
            <div class="popper">
              <h4 class="navbar__locales-title">{{ $t('component.navbar.pickLocale') }}</h4>
              <div class="navbar__popper-flags">
                <div
                  class="navbar__popper-flags-item"
                  v-for="locale in locales"
                  :key="locale"
                  :class="[locale === $i18n.locale ? 'navbar__popper-flags-item--active' : '']"
                  @click="changeLocale(locale)"
                >
                  <country-flag
                    class="navbar__popper-flags-flag"
                    :country="flagFromLocale(locale)"
                  />
                </div>
              </div>
            </div>
            <fai class="navbar__button" icon="language" slot="reference"></fai>
          </popper>
        </div>
        <div class="navbar__user">
          <popper ref="userPopper" trigger="clickToOpen" :options="{ placement: 'bottom' }">
            <div class="popper navbar_popper-user" @click="logout">
              <btn
                class="navbar__logout-btn"
                small
                icon="sign-out-alt"
              >{{ $t('component.navbar.logout') }}</btn>
            </div>
            <div class="navbar__username" slot="reference">{{ $store.state.user.admin.name }}</div>
          </popper>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import store from '../store'

export default {
  data () {
    return {
      locales: [],
      logoRotated: false
    }
  },

  props: {
    iconLength: 0
  },

  watch: {
    iconLength: function (val) {
      this.$refs.logo.style.width = val + "px"
    }
  },

  computed: {
    username: function () {
      return ''
    }
  },

  mounted () {
    this.$refs.logo.style.width = this.iconLength + "px"
    axios.get('/api/system/locales').then(async (res) => {
      this.locales = res.data.locales
      await this.changeLocale(localStorage.getItem('locale'))
    })
  },

  methods: {
    logout () {
      this.$router.push('/logout')
    },

    flagFromLocale (locale) {
      if (locale === 'en') return 'gb'
      return locale
    },

    async changeLocale (locale) {
      if (locale === this.$i18n.locale) return
      try {
        this.$root.$i18n.locale = locale
        this.$refs.localePopper.doClose()
        await axios.put('/api/account/locale', {
          locale
        })
        localStorage.setItem('locale', locale)
      } catch (e) {
        console.error(e)
      }
    }
  }
}
</script>

<style lang="scss">
.navbar {
  @include boxShadow(0px, -2px, 15px, -10px, rgba(0, 0, 0, 0.75));
  display: flex;
  font-weight: bold;
  font-size: 1.2em;
  height: 58px;
  min-height: 58px; //Safari fix?
  z-index: 1001;
  background-color: white;

  &__route-name {
    font-size: 1.2em;
  }

  &__logo-container {
    background-color: $primary;
    display: flex;
    align-items: center;
    justify-content: center;
    transform: skew(25deg);
    transform-origin: center bottom;
    min-width: 122px;
  }

  &__logo {
    color: white;
    width: 34px;
    transform: skew(-25deg);
    transform-origin: center bottom;
  }

  &__content {
    flex-grow: 1;
    padding: 12px 16px;
    display: flex;
    align-items: center;
  }

  &__segment {
    display: flex;
  }

  &__filler {
    flex-grow: 1;
  }

  &__buttons {
    margin-right: 32px;
    display: flex;
    align-items: center;
  }

  &__button {
    cursor: pointer;
    padding: 5px;
    font-size: 1.2em;
    margin-left: 14px;
    border-radius: 5px;
  }

  &__user {
    display: flex;
    align-items: center;
    cursor: pointer;
  }

  &__username {
    user-select: none;
    margin-right: 10px;
    font-size: 0.9em;
  }

  &__popper-flags {
    @include alignedFlex(flex-start);
    flex-wrap: wrap;
    width: 120px;
  }

  &__popper-flags-item {
    cursor: pointer;
    width: 34px;
    height: 26px;
    border-radius: 3px;
    margin: 3px 2px 0 2px;
    border: 1px white solid;

    &--active {
      border: 1px $danger solid;
    }
  }

  &__popper-flags-flag {
    position: relative;
    top: -3px;
  }

  &__popper-user-icon {
    margin: 5px;
    font-size: 1.8em;
  }

  &__logout-btn {
    margin-top: 3px;
  }

  &__locales-title {
    text-align: left;
    margin-top: 0;
    margin-bottom: 5px;
  }
}
</style>